/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import * as Constants from '../../core/Constants';
import { getImageURL, getHostCURL } from '../../common/utils/cardUtils';
import { handleTileAnalytics } from '../../common/utils/AnalyticsUtils';
import './PromotionSection.scss';

const { promotionText } = Constants;
const analytics = Constants.analytics.PROMOTION;

const PreferredPricingPromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/b2b/account/view/proXtraPricing')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.PreferredPricingPromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.PreferredPricingPromo}</div>
        <div className="PromotionSection__subLink">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="38"
          height="34"
          src={getImageURL('WelcomeCard/PP_RGB_Orange-Black.svg')}
          alt="PP_RGB_Orange-Black"
        />
      </div>
    </a>
  );
};

const VolumePricingPromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/b2b/account/view/proXtraPricing')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.VolumePricingPromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.VolumePricingPromo}</div>
        <div className="PromotionSection__subLink">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="45px"
          height="35px"
          src={getImageURL('volume-pricing.svg')}
          alt="volume-pricing"
        />
      </div>
    </a>
  );
};

const PlccAcquisitionPromo = ({ activePxccFactor }) => {
  const spendMultiplier = activePxccFactor || 4;
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/c/Credit_Center#RevolvingChargeCard')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.PlccAcquisitionPromo)}
      rel=" noreferrer"
    >
      <div className="col__9-12">
        <div>{promotionText.PlccAcquisitionPromo}</div>
        <div className="PromotionSection__subLink">
          <span>Earn Perks {spendMultiplier}X Faster</span>
        </div>
      </div>
      <div className="col__3-12 PromotionSection__arrowMain">
        <Image
          className="cardImage"
          src={getImageURL('plcc-angled.svg')}
          alt="plcc-angled"
        />
      </div>
    </a>
  );
};

const TextToConfirmPromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/b2b/account/view/paymentcards')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.TextToConfirmPromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.TextToConfirmPromo}</div>
        <div className="PromotionSection__subLink">
          <span>Learn About Text2Confirm</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="29.32px"
          height="35px"
          src={getImageURL('text-confirm.svg')}
          alt="text-confirm"
        />
      </div>
    </a>
  );
};

const PaintProductsPromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href=""
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.PaintProductsPromo}</div>
        <div className="PromotionSection__subLink">
          <span>View Details</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="28.08px"
          height="36px"
          src={getImageURL('WelcomeCard/icon-PaintRewards.svg')}
          alt="icon-PaintRewards"
        />
      </div>
    </a>
  );
};

const ProXtraGeneralKnowledgePromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/b2b/account/view/proxtraprogramdetails')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.ProXtraGeneralKnowledgePromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.ProXtraGeneralKnowledgePromo}</div>
        <div className="PromotionSection__subLink">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="36px"
          height="37px"
          src={getImageURL('pro-extra-perk.svg')}
          alt="pro-extra-perk"
        />
      </div>
    </a>
  );
};

const ManageProjectMore = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href=""
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.ManageProjectMore}</div>
        <div className="PromotionSection__subLink">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__arrowMain">
        <Image
          width="54px"
          height="39px"
          src={getImageURL('plcc-angled.svg')}
          alt="plcc-angled"
        />
      </div>
    </a>
  );
};

const RegisteredTender = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/b2b/account/view/paymentcards')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.RegisteredTender)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.RegisteredTender}</div>
        <div className="PromotionSection__subLink">
          <span>Register A Card</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="35"
          height="36px"
          src={getImageURL('registered-tender.svg')}
          alt="registered-tender"
        />
      </div>
    </a>
  );
};

const AppAwarenessPromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/c/SF_Mobile_Shopping')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.AppAwarenessPromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.AppAwarenessPromo}</div>
        <div className="PromotionSection__subLink">
          <span>Explore the App</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="20px"
          height="35px"
          src={getImageURL('app-awareness.svg')}
          alt="app-awareness"
        />
      </div>
    </a>
  );
};

const ProOnlineExperiencePromo = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      data-testid=""
      href={getHostCURL('/c/overview_pro_onboarding')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.ProOnlineExperiencePromo)}
      rel=" noreferrer"
    >
      <div className="col__10-12">
        <div>{promotionText.ProOnlineExperiencePromo}</div>
        <div className="PromotionSection__subLink">
          <span>Learn More</span>
        </div>
      </div>
      <div className="col__2-12 PromotionSection__closerGetting">
        <Image
          width="40px"
          height="29.63px"
          src={getImageURL('pro-online-experience.svg')}
          alt="pro-online-experience"
        />
      </div>
    </a>
  );
};

const RenderPromotionTiles = ({ tiles }) => {
  return (
    <div data-testid="">
      {(tiles?.length < Constants.TILE_LIMIT)
      && <p className="PromotionSection__benefitsLabel">More Great Pro Xtra Benefits</p>}
      {tiles}
    </div>
  );
};

export const showingTilePromotions = ({ isAdmin, userData }) => {
  const { preferredPricingTierZero } = userData?.customerInfo || {};
  const { pxccUserCategory } = userData?.perkSummary || {};
  const showingTile = {
    RegisteredTender: true,
    PreferredPricingPromo: preferredPricingTierZero,
    PlccAcquisitionPromo: isAdmin && pxccUserCategory === 'Targeted',
    AppAwarenessPromo: true,
    ProOnlineExperiencePromo: true,
    VolumePricingPromo: true,
    TextToConfirmPromo: isAdmin,
    ProXtraGeneralKnowledgePromo: true,
    PaintProductsPromo: false,
    ManageProjectMore: false,
  };
  return showingTile;
};

export const prioritizedListPromotions = ({ showingTile, userData }) => {
  const { activePxccFactor } = userData?.perkSummary || {};
  const prioritizedList = [
    showingTile.RegisteredTender && <RegisteredTender />,
    showingTile.PreferredPricingPromo && <PreferredPricingPromo />,
    showingTile.PlccAcquisitionPromo && <PlccAcquisitionPromo activePxccFactor={activePxccFactor} />,
    showingTile.AppAwarenessPromo && <AppAwarenessPromo />,
    showingTile.ProOnlineExperiencePromo && <ProOnlineExperiencePromo />,
    showingTile.VolumePricingPromo && <VolumePricingPromo />,
    showingTile.TextToConfirmPromo && <TextToConfirmPromo />,
    showingTile.ProXtraGeneralKnowledgePromo && <ProXtraGeneralKnowledgePromo />,
    showingTile.PaintProductsPromo && <PaintProductsPromo />,
    showingTile.ManageProjectMore && <ManageProjectMore />,
  ];
  return prioritizedList;
};

const PromotionSection = ({ tiles }) => {

  return <RenderPromotionTiles tiles={tiles} />;
};

export const exportsForTesting = {
  RegisteredTender,
  PreferredPricingPromo,
  PlccAcquisitionPromo,
  AppAwarenessPromo,
  ProOnlineExperiencePromo,
  VolumePricingPromo,
  TextToConfirmPromo,
  ProXtraGeneralKnowledgePromo,
  PaintProductsPromo,
  ManageProjectMore,
  RenderPromotionTiles,
};

export default PromotionSection;